import { render, staticRenderFns } from "./detailed_info.vue?vue&type=template&id=5908d5c8&scoped=true&"
import script from "./detailed_info.vue?vue&type=script&lang=js&"
export * from "./detailed_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5908d5c8",
  null
  
)

export default component.exports